/**
* initWebChatFocusOrder
* @param {Object}  [options]
* @param {string}  [options.chatSelector='#custom-launcher']  CSS selector for chat button
* @param {string}  [options.launcherId='launcher']            ID of the chat launcher container
* @param {string}  [options.faqId='faq']              ID of the FAQ section
* @param {string}  [options.footerId='footer']                ID of the footer
* @returns {function} cleanup — call this to undo all changes
*/
export function initWebChatFocusOrder(options) {
  var opts = options || {};
  var chatSelector = opts.chatSelector || '#custom-launcher';
  var launcherId   = opts.launcherId   || 'launcher';
  var faqId        = opts.faqId        || 'faq';
  var footerId     = opts.footerId     || 'footer';
 
  var cleanupFn = null;
  var observer  = null;

  function getAnchor() {
    var faq = document.getElementById(faqId);
    if (faq) return faq;
    return document.getElementById(footerId) || null;
  }
 
  function getClosestBgColor(element) {
    var current = element ? element.parentElement : null;
    while (current && current !== document.documentElement) {
      var bg = window.getComputedStyle(current).backgroundColor;
      if (bg && bg !== 'transparent' && bg.indexOf('rgba(0, 0, 0, 0)') === -1) {
        return bg;
      }
      current = current.parentElement;
    }
    return '#000000';
  }
 
  function toHex(rgb) {
    if (rgb.charAt(0) === '#') return rgb;
    var parts = rgb.match(/\d+/g);
    if (!parts) return '#000000';
    return '#' + parts.slice(0, 3).map(function (n) {
      return ('0' + parseInt(n, 10).toString(16)).slice(-2);
    }).join('');
  }
 
  function isLight(hex) {
    hex = hex.replace('#', '');
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.5;
  }
 
 
  function setup(chatButton) {
    var anchor = getAnchor();
    if (!anchor) return;
 
    var launcher =
      document.getElementById(launcherId) ||
      chatButton.parentElement;
 
    var originalParent = launcher.parentNode;
    var originalNext   = launcher.nextSibling;
 
    anchor.parentNode.insertBefore(launcher, anchor);
 
    
    function onFocus() {
      requestAnimationFrame(function () {
        try {
          if (!chatButton.matches(':focus-visible')) return;
        } catch (_) {
          // :focus-visible not supported — always show
        }
 
        var bg    = getClosestBgColor(chatButton);
        var hex   = toHex(bg);
        var color = isLight(hex) ? '#dd1d78' : '#F5EBDA';
 
        chatButton.style.setProperty('outline', `3px solid ${color}`, 'important');
        chatButton.style.setProperty('outline-offset', '3px', 'important');
        chatButton.style.setProperty('border-radius','50%','important');
      });
    }
 
    function onBlur() {
      chatButton.style.removeProperty('box-shadow');
      chatButton.style.removeProperty('border-radius');
    }
 
    chatButton.addEventListener('focus', onFocus);
    chatButton.addEventListener('blur', onBlur);
 
    
    cleanupFn = function () {
      if (originalNext && originalParent.contains(originalNext)) {
        originalParent.insertBefore(launcher, originalNext);
      } else if (originalParent) {
        originalParent.appendChild(launcher);
      }
      chatButton.removeEventListener('focus', onFocus);
      chatButton.removeEventListener('blur', onBlur);
      onBlur();
    };
  }
 
  
 
  var chatButton = document.querySelector(chatSelector);
  if (chatButton) {
    setup(chatButton);
  } else {
    observer = new MutationObserver(function (mutations, obs) {
      var btn = document.querySelector(chatSelector);
      if (btn) {
        obs.disconnect();
        observer = null;
        setup(btn);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
 

  return function destroy() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    if (cleanupFn) {
      cleanupFn();
      cleanupFn = null;
    }
  };
}